import { render, staticRenderFns } from "./KernelOrderItemAttributesView.vue?vue&type=template&id=cd94ad58&"
import script from "./KernelOrderItemAttributesView.vue?vue&type=script&lang=js&"
export * from "./KernelOrderItemAttributesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports